var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Skeleton',{style:({ 'margin-bottom': '4rem' }),attrs:{"height":"3rem","width":"198px"}}),_vm._l((10),function(i){return _c('Skeleton',{key:i,style:({ padding: '0.5rem' }),attrs:{"width":"100%","height":"auto"}},[_c('Skeleton',{style:({ 'margin-bottom': 0 }),attrs:{"color":"#E3E3E3","height":"64px","width":"64px"}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }